export default __webpack_public_path__ + "static/bed-bath-beyond-8-c-d0a7dd9fa2687a9c9765517c6b8c7bb8.webp";